export default __webpack_public_path__ + "static/g2-2025-banner-9b7737ba45e58c01e4e122bf1a08c322.jpg";